import type { Verification } from '../types/verification.types';

/** A referee who neither commented nor answered anything has nothing to expand. */
export function hasRefereeResponse(verification: Verification): boolean {
  const hasComment = Boolean(verification.refereeComment?.trim());
  const hasAnswers = (verification.refereeAnswers ?? []).some(
    (answer) => answer.answerText.trim().length > 0
  );
  return hasComment || hasAnswers;
}
